






















import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation, namespace } from "vuex-class";
import { SupportCustomerFeedback } from "@/http/api/v2/supporter/customerFeedback";

const HotelModule = namespace("HotelModule");

@Component({
  components: {},
})
export default class SupportMenu extends Vue {
  @HotelModule.State("hotelInfo") hotelInfo: any;
  feedbackUnreadCount = 0;
  feedbackUnreadTimer: number | null = null;

  menuSections = [
    {
      title: "운영 현황",
      menus: [{ key: "support-dashboard", title: "대시보드" }],
    },
    {
      title: "고객 관리",
      menus: [
        { key: "support-hotel", title: "호텔 관리" },
        { key: "support-user", title: "사용자 관리" },
        { key: "support-feedback", title: "고객 의견" },
      ],
    },
    {
      title: "데이터 분석",
      menus: [
        { key: "support-feature-analytics", title: "기능 사용 분석" },
        { key: "support-issue", title: "이슈 관리" },
        { key: "support-notice", title: "게시글 관리" },
      ],
    },
    {
      title: "운영 도구",
      menus: [
        { key: "support-advertisement", title: "광고 관리" },
        { key: "support-popup", title: "팝업 관리" },
        { key: "support-version", title: "버전 관리" },
      ],
    },
  ];

  get activeKey() {
    return this.$route.name;
  }

  mounted() {
    this.loadFeedbackUnreadCount();
    this.$root.$on("support-feedback-read", this.loadFeedbackUnreadCount);
    this.feedbackUnreadTimer = window.setInterval(this.loadFeedbackUnreadCount, 60000);
  }

  beforeDestroy() {
    this.$root.$off("support-feedback-read", this.loadFeedbackUnreadCount);
    if (this.feedbackUnreadTimer !== null) {
      window.clearInterval(this.feedbackUnreadTimer);
    }
  }

  async loadFeedbackUnreadCount() {
    try {
      const result = await SupportCustomerFeedback.unreadCount();
      this.feedbackUnreadCount = result.unreadCount;
    } catch {
      // 메뉴 탐색을 방해하지 않도록 알림 집계 오류는 다음 주기에 다시 시도합니다.
    }
  }
}
